import { getApiUrl } from "../utils/get-api-url";

export const handleIXDirectoryAuth = async (username, b64Val) => {
  const apiUrl = getApiUrl("ixdirectory");
  const fullUrl = `${apiUrl}/identities/${username}`;
  const response = await fetch(fullUrl, {
    method: "GET",
    headers: {
      Authorization: `Basic ${b64Val}`,
      "Content-Type": "text/xml"
    }
  });
  const { statusText, ok } = response;
  const xml = await response.text();
  if (!ok) throw new Error(xml.message || statusText);
  return xml;
};
